module.exports = __webpack_public_path__ + "img/pttr.44009840.svg";